// hooks/useSubsetores.js
import { useState, useEffect, useMemo } from "react"
import CalcService from "src/services/calc-service"

export function useSubsetores(setor = null) {
  const [options, setOptions] = useState([])
  const calcService = useMemo(() => new CalcService(), [])

  useEffect(() => {
    let mounted = true

    const fetchSubsetores = async () => {
      try {
        const result = await calcService.recuperaSubsetores(setor)

        const optionsAsStrings = result.map(item => {
          if (item && typeof item === "object") {
            return item.label ?? JSON.stringify(item)
          }
          return String(item)
        })

        if (mounted) setOptions(optionsAsStrings)
      } catch (err) {
        console.error("Erro ao carregar Subsetores:", err)
      }
    }

    fetchSubsetores()

    return () => { mounted = false }
  }, [calcService, setor])

  return options
}